import { Action } from '@reduxjs/toolkit';

import { prepareAction } from '../helpers';

import { SET_TRAITS_DASHBOARD_SLUG } from './types';

export const setTraitsDashboardSlug = (dashboardSlug: string): Action =>
  prepareAction(SET_TRAITS_DASHBOARD_SLUG, { dashboardSlug });
